import get from 'lodash/get';

const isAddressType = (address, type) =>
  !!address.types.find((e) => e === type);

export default function parseAddress(address) {
  const streetNum = address.find((e) => isAddressType(e, 'street_number'));
  const route = address.find((e) => isAddressType(e, 'route'));
  const locality = address.find((e) => isAddressType(e, 'locality'));
  // This handles cities like new york that have boroughs.
  const subLocality = address.find((e) => isAddressType(e, 'sublocality'));
  const adminLevel = address.find((e) =>
    isAddressType(e, 'administrative_area_level_1')
  );
  const postalCode = address.find((e) => isAddressType(e, 'postal_code'));
  const countryItem = address.find((e) => isAddressType(e, 'country'));
  const political = address.find((e) => isAddressType(e, 'political'));
  const street = [get(streetNum, 'longText', null), get(route, 'shortText', '')]
    .filter((e) => !!e)
    .join(' ');
  const city = get(locality, 'longText', get(subLocality, 'longText', null));
  const state = get(adminLevel, 'shortText', null);
  const zip = get(postalCode, 'shortText', null);
  const country = get(
    countryItem,
    'longText',
    get(political, 'longText', null)
  );
  return { street, city, state, zip, country };
}
